// extracted by mini-css-extract-plugin
module.exports = {"create-new-menu":"inspector_create-new-menu__1q1Cp","menu-item-container":"inspector_menu-item-container__1JasY","item-type-container":"inspector_item-type-container__33cSQ"};